import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { productCategory } from "../../../types";

interface InventoryPesticideFilterProps {
  filter: productCategory;
  setFilter: (filter: productCategory) => void;
}

export const InventoryPesticideFilter: React.FC<InventoryPesticideFilterProps> = ({ filter, setFilter }) => {
  return (
    <Row  style={{paddingBottom: '10px'  }}>
      <Col xs={12}>
        <Form.Select 
          value={filter}
          onChange={(e) => setFilter(e.target.value as productCategory)}
          style={{ width: 'auto' }}
        >
          <option value="ALL">Tous</option>
          <option value="INSECTICIDE">Insecticide</option>
          <option value="FONGICIDE">Fongicide</option>
          <option value="NUTRITION RACINAIRE">Nutrition racinaire</option>
          <option value="NUTRITION FOLIAIRE">Nutrition foliaire</option>
        </Form.Select>
      </Col>
    </Row>
  );
};
